import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const coinMarketCap = defineConnector({
  identifier: "coinMarketCap",
  name: "CoinMarketCap",
  tagLine: "Cryptocurrency prices and rankings",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://pro-api\\.coinmarketcap\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "X-CMC_PRO_API_KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign up at the [CoinMarketCap developer portal](https://pro.coinmarketcap.com/account) and copy your API key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://pro-api.coinmarketcap.com/v1/key/info",
  },
});
